'use strict';

var log = require('../../log/Log').channel('ContactUtilityService');

angular.module('inara').factory('ContactUtilityService', ContactUtilityService);

ContactUtilityService.$inject = [];

function ContactUtilityService() {
    log.info('initializing');

    var contactAvatarColors = [
        { bg: 'tan', fg: 'white' },
        { bg: 'seagreen', fg: 'white' },
        { bg: 'cadetblue', fg: 'white' },
        { bg: 'olive', fg: 'white' },
        { bg: 'saddlebrown', fg: 'white' },
        { bg: 'olivedrab', fg: 'white' },
        { bg: 'indianred', fg: 'white' },
        { bg: 'slategray', fg: 'white' }
    ];

    return {
        getContactInitials: getContactInitials,
        getContactPictureStyle: getContactPictureStyle
    };

    function getContactInitials(entry) {
        var initials = '';
        if (entry.firstName &&
            entry.firstName.length > 0 &&
            entry.lastName &&
            entry.lastName.length > 0) {
            initials = entry.firstName[0] + entry.lastName[0];
        }
        else if (entry.firstName &&
                 entry.firstName.length > 1) {
            initials = entry.firstName.substr(0, 2);
        }
        else if (entry.lastName &&
                 entry.lastName.length > 1) {
            initials = entry.lastName.substr(0, 2);
        }
        else if (entry.displayName &&
                 entry.displayName.length > 1) {
            initials = entry.displayName.substr(0, 2);
        }
        return initials;
    }

    function getContactPictureStyle(entry, addCacheBuster) {
        var url = angular.isDefined(entry) && 
                  angular.isDefined(entry.picture) ? entry.picture.trim() : '';
        if (addCacheBuster) {
            url = url + (url.indexOf('?') > -1 ? '&' : '?') + 'inara-cache-version=' + Date.now();
        }
        var style = {
            'background-image': 'url(\'' + url + '\')'
        };
        if (!angular.isDefined(entry) || 
            !angular.isDefined(entry.picture)) {
            var avatarColor =
                contactAvatarColors[Math.floor(Math.random() * contactAvatarColors.length)];
            style.color = avatarColor.fg;
            style['background-color'] = avatarColor.bg;
        }
        return style;
    }
}